<template>
  <el-dialog title="修改介绍" :visible.sync="dialogVisible" @close="$emit('update:visible',false)" :close-on-click-modal="false">
    <div class="dialog_conwrap">
      <el-form ref="form" label-width="20px">
        <el-form-item label="">
          <div class="">
            <p class="infodescribe">注：一个月只能申请3次修改</p>
            <p class="infodescribe">审核将会在7个工作日完成，请确认是否提交修改申请</p>
          </div>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="formData" placeholder="请输入功能介绍" type="textarea" maxlength="120" show-word-limit class="textareaBody"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit">确认</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import api from "@/api.js";

  export default {
    name: "enterpriseAddressDialog",
    props: ["visible", "formData"],
    mounted() {
      this.$emit('update:formData', this.form)
    },
    created() {
      this.form = this.formData
    },
    data() {
      return {
        dialogVisible: this.visible,
        // formData: ''
      };
    },
    methods: {
      onSubmit() {
        if (!this.formData) {
          this.$message.error('请填写企业简介');
          return
        }
        this.axios
            .post(api.company_modifysignature, {signature: this.formData})
            .then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: '',
                });
                this.$emit('editFrom');
                this.dialogVisible = false
              } else {
                if (response.data.href_url) {
                  this.$alert(`<span class="text-align: center">只允许通过api创建的小程序使用<br/>请手动点击跳转到<a target="_blank" href="${response.data.href_url}" style="color: #409eff">公众号后台</a>修改</span>`, '提示', {
                    dangerouslyUseHTMLString: true,
                    center: true
                  }).then(() => {

                  }).catch(() => {});
                } 
              }
            })
            .catch(response => {
            });
      }
    }
  };
</script>

